import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsTab from 'contents_tab';

import Conditions  from '@common/influencer-search/conditions/_conditions';
import List        from '@common/influencer-search/list/_list';
import Post        from '@common/influencer-search/post/_post';
import Register    from '@common/influencer-search/register/_register';
// -------------------------------------------------------

class SearchCommon extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab        : 'person_search',
      //tab        : 'post_search',
      data       : {},
      options    : {},
      loading    : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 初回データ取得
   */
  componentDidMount() {
    this.searchInfluencer.bind(this)({});
  }
  // -------------------------------------------------------
  
  /*
   * タブの変更
   */
  refreshAction(tab) {
    //let options = this.state.options;
    //delete options.order;
    this.setState({ tab: tab, refresh: true, data: { items: [] }, options: {} });
    
    setTimeout( function(){
      this.setState({ refresh: false });
      this.searchInfluencer.bind(this)(this.state.options);
    }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  /*
   * タブの変更
   */
  moreAction() {
    let options = this.state.options;
    options.offset = this.state.data.items.length;
    this.searchInfluencer.bind(this)(options);
  }
  // -------------------------------------------------------
  
  searchInfluencer(option) {
    option.favorite = (this.state.tab == 'favorite') ? true : false;
    option.register = (this.state.tab == 'register') ? true : false;
    
    if( option.offset != undefined && option.offset > 0 ){
      this.setState({ options: option });
    } else {
      this.setState({ data: { items: [] }, options: option });
    }
    
    setTimeout( function(){
      if( this.state.loading == true ) return;
      this.setState({ loading: true });
      
      if( option.order == undefined ){
        try {
          let ele = document.getElementById('search-order');
          let m = ele.value.split(':');
          option.order = { column: m[0], type: m[1] };
        } catch(e) {}
      }
      
      Utils.request.bind(this)('/api/influencer/search', { option: option, mode: this.state.tab },
        function(res){
          
          setTimeout( function(){
            let items = this.state.data.items.concat();
            res.body.items.map((d) => { items.push(d); });
            
            this.setState({ data: {
              items      : items,
              item_count : res.body.count
            } });
            this.setState({ loading: false });
          }.bind(this), 50);
          
        }.bind(this)
      );
      
    }.bind(this), 50);
    
  }
  // -------------------------------------------------------
  
  render() {
    let tab = this.state.tab;
    let base = this.props.base;
    
    // タブリスト
    let tabs = [
      { id: 'person_search', name: 'アカウント検索', html: <List data={this.state.data} base={base} options={this.state.options} more_ev={this.moreAction.bind(this)} search_ev={this.searchInfluencer.bind(this)} /> },
      { id: 'favorite',      name: 'お気に入り',     html: <List data={this.state.data} base={base} options={this.state.options} more_ev={this.moreAction.bind(this)} search_ev={this.searchInfluencer.bind(this)} /> },
      { id: 'post_search',   name: '投稿検索',       html: <Post data={this.state.data} base={base} options={this.state.options} more_ev={this.moreAction.bind(this)} search_ev={this.searchInfluencer.bind(this)} /> },
      { id: 'register',      name: '新規登録',       html: <Register data={this.state.data} base={base} refresh_ev={this.refreshAction.bind(this)} /> },
    ];
    
    return (
      <div className="influencer-search-common">
        <Conditions base={base} tab={this.state.tab} options={this.state.options} refresh={this.state.refresh} search_ev={this.searchInfluencer.bind(this)} />
        
        <div className="search-contents">
          <ContentsTab tabs={tabs} select={this.state.tab} font_size={16} mode="hide" update_ev={this.refreshAction.bind(this)} />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SearchCommon;